<template>
  <div :id="divID" class="curated-page-list" :data-title="curatedPageList.title">
    <h3 v-if="curatedPageList.title && curatedPageList.title != ''" class="h4 uppercase text-center">
      {{ curatedPageList.title }}
    </h3>

    <!--NOTES
      1.) Possible property for "item-spacing(carousel only)","showNav(carousel only)", "cardWidth(villa card only)" and "cardHeight(villa card only)" to editable Curated List Module in CMS Editor ???
    -->
    <!--for CAROUSEL with VILLA CARDS-->
    <carousel v-if="curatedPageList && curatedPageList.items && curatedPageList.items.length > 0 && curatedPageList.templateType === 'carousel' && curatedPageList.cardType === 'normal'"
              :key="getNewKey(1)"
              :items="curatedPageList.items"
              item-type="VillaCard"
              :show-nav="!(curatedPageList.items.length === curatedPageList.itemsInView)"
              :items-in-view="curatedPageList.itemsInView"
              :item-spacing="20"
              :bleed-edges="!(curatedPageList.items.length === curatedPageList.itemsInView)"
              :fade-item-sides="!(curatedPageList.items.length === curatedPageList.itemsInView)"
    />

    <!--for CAROUSEL with READ MORE BLOCKS-->
    <carousel v-else-if="curatedPageList && curatedPageList.items && curatedPageList.items.length > 0 && curatedPageList.templateType === 'carousel' && curatedPageList.cardType === 'readmore'"
              :key="getNewKey(1)"
              :items="curatedPageList.items"
              item-type="ReadMoreBlock"
              :show-nav="!(curatedPageList.items.length === curatedPageList.itemsInView)"
              :items-in-view="curatedPageList.itemsInView"
              :item-spacing="0"
              :bleed-edges="!(curatedPageList.items.length === curatedPageList.itemsInView)"
              :fade-item-sides="!(curatedPageList.items.length === curatedPageList.itemsInView)"
    />

    <!--for CAROUSEL with COLLECTION BLOCKS-->
    <carousel v-else-if="curatedPageList && curatedPageList.items && curatedPageList.items.length > 0 && curatedPageList.templateType === 'carousel' && curatedPageList.cardType === 'collection'"
              :key="getNewKey(1)"
              :items="curatedPageList.items"
              item-type="Collections"
              :show-nav="!(curatedPageList.items.length === curatedPageList.itemsInView)"
              :items-in-view="curatedPageList.itemsInView"
              :item-spacing="0"
              :bleed-edges="!(curatedPageList.items.length === curatedPageList.itemsInView)"
              :fade-item-sides="!(curatedPageList.items.length === curatedPageList.itemsInView)"
    />

    <!--for CAROUSEL_NEW with COLLECTION BLOCKS - home page collection - most properties are ignored-->
    <carousel-ssr v-else-if="curatedPageList && curatedPageList.items && curatedPageList.items.length > 0 && curatedPageList.templateType === 'carousel_new' && curatedPageList.cardType === 'collection'"
                  :key="getNewKey(1)"
                  :items="curatedPageList.items"
                  item-type="Collections"
                  :show-nav="!(curatedPageList.items.length === curatedPageList.itemsInView)"
                  :items-in-view="curatedPageList.itemsInView"
                  :item-spacing="0"
                  :bleed-edges="!(curatedPageList.items.length === curatedPageList.itemsInView)"
                  :fade-item-sides="!(curatedPageList.items.length === curatedPageList.itemsInView)"
    />

    <!--for POLAROIDS with VILLA CARDS or READ MORE BLOCKS-->
    <!--NOTE: :DESCRIPTION could be the collection's VILLA COUNT if item type is Collection-->
    <div v-else-if="curatedPageList && curatedPageList.items && curatedPageList.items.length > 0 && curatedPageList.templateType === 'polaroid'">
      <div class="wrapper">
        <div class="villa-collections">
          <div v-for="(villa, index) in curatedPageList.items" :key="`villatop${index}${moduleId}`" tabindex="0">
            <read-more-block v-if="curatedPageList.cardType === 'readmore'" :img-u-r-l="villa.imgURL" :link-i-d="villa.link" :link-type="villa.linkType" :title="villa.title" :description="villa.description" />
            <villa-card v-else-if="curatedPageList.cardType === 'normal'" :key="`v${index}${moduleId}`" :img-u-r-l="villa.imgURL" :link-i-d="villa.link" :link-type="villa.linkType" :title="villa.title" :description="villa.description" :card-width="villa.cardsWidth" :card-height="villa.cardsHeight" />
            <collections v-else-if="curatedPageList.cardType === 'collection'" :key="`c${index}${moduleId}`" :img-u-r-l="villa.imgURL" :link-i-d="villa.link" :link-type="villa.linkType" :title="villa.title" :description="villa.description" :card-width="villa.cardsWidth" :card-height="villa.cardsHeight" />
          </div>
        </div>
      </div>
    </div>

    <!--:items-in-view="parseInt(curatedPageList.itemsInView)"-->
    <!--<div v-if="curatedPageList && curatedPageList.items.length > 0 && curatedPageList.templateType === 'polaroid'" class="background-offwhite topSpace50">
    <div class="wrapper">
      <div class="villa-collections">
        <div v-for="(item, index) in curatedPageList.items" :key="`villatest${index}${moduleId}`">

          <read-more-block v-if="curatedPageList.cardType === 'readmore'" :imgURL="item.imageUrl" :linkID="item.entityId" :title="item.title" :description="item.description" :responsive="false" />
          <villa-card v-else="curatedPageList.cardType === 'normal'" :imgURL="item.imageUrl" :linkID="item.entityId" :title="item.title" :description="item.villas" cardWidth="420px" :key="`v${index}${moduleId}`" />

        </div>
      </div>
    </div>
  </div>-->
  </div>
</template>
<script>
import Carousel from '../gallery/Carousel.vue';
import CarouselSsr from '../gallery/CarouselSsr.vue';
import VillaCard from '../VillaCard.vue';
import ReadMoreBlock from '../ReadMoreBlock.vue';
import Bus from '../../events/bus';
import Collections from './CMSCollections.vue';

export default {
  components: {
    Carousel,
    CarouselSsr,
    VillaCard,
    ReadMoreBlock,
    Collections,
  },
  props: {
    settings: {
      required: true,
    },
  },
  computed: {
    divID() {
      if (this.curatedPageList.title) {
        return this.curatedPageList.title.split(' ').join('-');
      }
    },

    curatedPageList() {
      const curatedList = this.settings.find((s) => s.name == 'curatedList');
      if (curatedList) {
        const objCuratedList = JSON.parse(curatedList.value);
        if (objCuratedList.items) {
          // each item needs a link(linkId = pageId,villaId,collectionId etc) property to be compatible with wrapped carousel control (link can be an URL in the case of Manual linkType)
          objCuratedList.items.forEach((i) => {
            if (i.linkType && i.linkType !== 'manual') i.link = String(i.linkID);
            else i.link = i.linkURL;
          });
          objCuratedList.items.forEach((i) => {
            if (i.cardsWidth && i.cardsWidth != '') { i.cardsWidth += 'px'; }
            if (i.cardsHeight && i.cardsHeight != '') { i.cardsHeight += 'px'; }
          });
        }
        return objCuratedList;
      }

      return null;
    },

    moduleId() {
      if (this.settings.length > 0) {
        return this.settings[0].moduleId;
      }
    },
  },
  mounted() {
    Bus.$emit('cms-curated-page-list-mounted', this.curatedPageList);
  },
  methods: {
    getNewKey(num) {
      const uuidv4 = require('uuid/v4');
      let nk = uuidv4();
      nk = `${nk}${num}`;
      return nk;
    },
  },
};

</script>

<style lang="scss" scoped>

  @import "../../assets/styles/settings/config.scss";

  //----- VILLA COLLECTIONS ------//
  .villa-collections {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }

// This is specifically for the guide page, but will see what else it affects. - Julia
// This is also on the home page but works fine
  .curated-page-list {
    padding: .5em 0 .5em;
    overflow: hidden; //needed for carousel bug xscroll
    &:nth-child(even) {
      background-color: $stoneCream;
    }
    h4{
      margin: 20px 0 10px 0;
    }
  }
</style>
